import React from 'react'
import coming_soon_img from '../assets/images/coming_soon.jpg'

const Soon = () => {
    return (
        <div className='text-white mb-5 mt-2 container-xxl'>
            <div className='d-flex justify-content-center align-items-center h-100 w-100' style={{minHeight:"70vh", maxHeight:"90vh"}}>
                <img alt='Comming soon...'src={coming_soon_img} />
            </div>
        </div>
    )
}

export default Soon
